import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import A from "../../assets/Sliders/A.jpg"
import B from "../../assets/Sliders/B.jpg"
import C from "../../assets/Sliders/C.jpg"
import D from "../../assets/Sliders/D.jpg"
import E from "../../assets/Sliders/E.jpg"
import F from "../../assets/Sliders/F.jpg"
import G from "../../assets/Sliders/G.jpg"
import H from "../../assets/Sliders/H.jpg"

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { ebanqoString } from '../../assets/scripts/ebanqo'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { post } from 'utility/fetch';
import { post as postTwo } from 'utility/fetchTwo';
import { useNavigate } from 'react-router-dom';

import OtpInput from "react-otp-input";
import { get } from 'utility/fetch';
import { useState } from 'react';
import notification from 'utility/notification';
import { ClipLoader, ClockLoader, DotLoader, RingLoader, SkewLoader } from 'react-spinners';
import { Helmet } from 'react-helmet';
import EbanqoHelmet from 'layouts/EbanqoHelmet';


const defaultTheme = createTheme();


export default function Login() {

    const [loginState, setLoginState] = useState({
        isSignUp: false,
        isLogin: true,
        isOTP: false,
        isRegister: false,
        isForgotPassword: false,
        isForgotPasswordToken: false,
    })
    const [otp, setOtp] = useState('')
    const [pin, setPin] = useState('')
    const [isUpdate, setIsUpdate] = useState(false);
    const [payload, setPayload] = useState(null)
    const [loading, setLoading] = useState(false)



    const checkOTP = async (value) => {
        setLoading(true)
        let res = await post("/validate-otp", { pin: pin, otp: value })
        console.log(res)
        if (res?.data?.statusCode === 200 || res?.status === 200) {
            //success
            notification({
                title: "Success",
                message: res?.data?.message,
                type: 'success'
            })
            setLoginState({
                isSignUp: false,
                isLogin: false,
                isOTP: false,
                isRegister: true,
            });
            setLoading(false)
        }
        else if (res.data.statusCode === 404) {
            setLoading(false)
            //account not found
            console.log("here")
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else if (res.data.statusCode === 500) {
            setLoading(false)
            //server error
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else if (res.data.statusCode === 503) {
            setLoading(false)
            //service unavailable
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else if (res.data.statusCode === 426) {
            setLoading(false)
            //notification
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else {
            setLoading(false)
            //notification
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
    }

    const signIn = async (load) => {
        setLoading(true)
        let res = await post("/applogin", { userPin: pin, password: load.password });
        console.log(load)

        console.log(res)
        if (res.data.statusCode === 200) {
            setLoading(false)
            //success
            notification({
                title: "Success",
                message: res?.data?.message,
                type: 'success'
            })
            navigate('/dashboard');
        }
        else if (res.data.statusCode === 404) {
            setLoading(false)
            //account not found
            console.log("here")
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else if (res.data.statusCode === 500) {
            setLoading(false)
            //server error
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else if (res.data.statusCode === 503) {
            setLoading(false)
            //service unavailable
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else if (res.data.statusCode === 426) {
            setLoading(false)
            //notification
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else {
            setLoading(false)
            //notification
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
    }


    const createProfile = async () => {
        setLoading(true)
        let res = await post("/create-profile", { ...payload, pin: pin })

        console.log(res)
        if (res.data.statusCode === 200) {
            setLoading(false)
            //success
            navigate('/dashboard');
        }
        else if (res.data.statusCode === 404) {
            setLoading(false)
            //account not found
            console.log("here")
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else if (res.data.statusCode === 500) {
            setLoading(false)
            //server error
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else if (res.data.statusCode === 503) {
            setLoading(false)
            //service unavailable
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else if (res.data.statusCode === 426) {
            setLoading(false)
            //notification
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else {
            setLoading(false)
            //notification
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
    }

    const auth = async () => {
        setLoading(true)
        let res = await post(`?pin=${payload.pin}`,)
        setPin(payload.pin);
        setOtp('');
        if (res?.data?.statusCode === 200 || res?.status === 200) {
            setLoading(false)
            //success
            notification({
                title: "success",
                message: res?.data?.message,
                type: 'success'
            })
            setLoginState({
                isSignUp: false,
                isLogin: false,
                isOTP: true,
                isRegister: false,
            });
            setPayload(null);

        }
        else if (res.data.statusCode === 404) {
            setLoading(false)
            //account not found
            console.log("here")
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else if (res.data.statusCode === 500) {
            setLoading(false)
            //server error
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else if (res.data.statusCode === 503) {
            setLoading(false)
            //service unavailable
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else if (res.data.statusCode === 426) {
            setLoading(false)
            //notification
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else {
            setLoading(false)
            //notification
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
    }

    const updateProfile = async () => {
        let res = await post("/update-profile", { ...payload, pin: pin })

        if (res.data.statusCode === 200) {
            setLoading(false)
            //success
            signIn(payload);
            notification({
                title: "Success",
                message: res?.data?.message,
                type: 'success'
            })
        }
        else if (res.data.statusCode === 404) {
            setLoading(false)
            //account not found
            console.log("here")
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else if (res.data.statusCode === 500) {
            setLoading(false)
            //server error
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else if (res.data.statusCode === 503) {
            setLoading(false)
            //service unavailable
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else if (res.data.statusCode === 426) {
            setLoading(false)
            //notification
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else {
            setLoading(false)
            //notification
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
    }

    const handleChange = (e) => {
        setPayload({
            ...payload,
            [e.target.name]: e.target.value
        })

    }



    const handleOTPChange = (newValue) => {
        setOtp(newValue)
        if (newValue.length === 4) {
            checkOTP(newValue);
        }
    }


    const forgotPassword = async () => {
        let res = await postTwo("/Auth/reset-password", payload)
        console.log(res);
        if (res?.status === 200) {
            setLoading(false)
            notification({
                title: "Success",
                message: res?.data?.message,
                type: 'success'
            })
            setLoginState({
                isSignUp: false,
                isLogin: false,
                isOTP: false,
                isRegister: false,
                isForgotPassword: false,
                isForgotPasswordToken: true,
            })
        }
        else {
            setLoading(false)
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }

    }


    const forgotPasswordToken = async () => {
        let res = await postTwo("/Auth/reset-password-with-token", payload)
        console.log(res);
        if (res?.status === 200) {
            setLoading(false)
            notification({
                title: "Success",
                message: res?.data?.message,
                type: 'success'
            })
            setLoginState({
                isSignUp: false,
                isLogin: true,
                isOTP: false,
                isRegister: false,
                isForgotPassword: false,
                isForgotPasswordToken: false,
            })
        }
        else {
            setLoading(false)
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }

    }



    const navigate = useNavigate();


    const handleSubmit = async (event) => {
        setLoading(true);
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        setPin(data.get("rsa"));

        if (loginState.isLogin) {
            let res = await post('/applogin', {
                userPin: data.get('rsa'),
                password: data.get('password'),
            })
            if (res.data.statusCode === 200) {
                setLoading(false)
                notification({
                    title: "Success",
                    message: res?.data?.message,
                    type: 'success'
                })
                sessionStorage.setItem('pin', res.data.data.pin)
                sessionStorage.setItem('email', res.data.data.email)
                sessionStorage.setItem('firstName', res.data.data.firstname)
                sessionStorage.setItem('surname', res.data.data.surname)
                sessionStorage.setItem('othernames', res.data.data.otherNames)
                sessionStorage.setItem('fundType', res.data.data.fundType)
                sessionStorage.setItem('employer', res.data.data.employer)
                sessionStorage.setItem('phoneNumber', res.data.data.mobile)
                sessionStorage.setItem('agentName', res.data.data.agentName)
                sessionStorage.setItem('agentEmail', res.data.data.agentEmail)
                sessionStorage.setItem('agentMobile', res.data.data.agentMobile)
                sessionStorage.setItem('isBirthdayToday', res.data.data.isBirthdayToday)
                sessionStorage.setItem('token', res.data.data.authenticationToken)

                navigate("/dashboard")
                //success
            }
            else if (res.data.statusCode === 404) {
                setLoading(false)
                //account not found
                notification({
                    title: "error",
                    message: res?.data?.message,
                    type: 'danger'
                })
            }
            else if (res.data.statusCode === 500) {
                setLoading(false)
                //server error
                notification({
                    title: "error",
                    message: res?.data?.message,
                    type: 'danger'
                })
            }
            else if (res.data.statusCode === 503) {
                setLoading(false)
                //service unavailable
                notification({
                    title: "error",
                    message: res?.data?.message,
                    type: 'danger'
                })
            }
            else if (res.data.statusCode === 426) {
                setLoading(false)
                setLoginState({
                    isSignUp: false,
                    isLogin: false,
                    isOTP: false,
                    isRegister: true,
                });

                setIsUpdate(true);
                //notification
            }
            else {
                //service unavailable
                setLoading(false);
                notification({
                    title: "error",
                    message: res?.data?.message,
                    type: 'danger'
                })
            }
        }
        else if (loginState.isForgotPassword) {
            forgotPassword();
        }
        else if (loginState.isForgotPasswordToken) {
            forgotPasswordToken();
        }
        else if (loginState.isSignUp) {
            auth();

        }
        else {
            if (isUpdate) {
                updateProfile();
            }
            else {
                console.log(payload)
                createProfile();
            }


        }


    };

    return (
        <ThemeProvider theme={defaultTheme}>
            <EbanqoHelmet />

            <Grid container component="main" sx={{
                height: '100vh'
            }}>
                <CssBaseline />

                <Grid
                    item
                    sx={{
                        display: { sm: "none", xs: "none", md: 'block', height:"100vh", width:"auto" }
                    }}
                    md={5}
                >
                    <Swiper
                        spaceBetween={30}
                        centeredSlides={true}
                        style={{ height: '100%' }}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        pagination={{
                            clickable: true,
                        }}
                        // navigation={true}
                        modules={[Autoplay, Pagination, Navigation]}
                        className="mySwiper"
                    >
                        <SwiperSlide>
                            <img src={A} alt="Login Image"
                                //   className="img-fluid object-contain full-screen-image"
                                style={{ height: '100%', width: "100%" }} />

                        </SwiperSlide>
                        <SwiperSlide>
                            <img src={B} alt="Login Image"
                                //   className="img-fluid object-contain full-screen-image"
                                style={{ height: '100%', width: "100%" }} />

                        </SwiperSlide>
                        {/* <SwiperSlide>
                            <img src={C} alt="Login Image"
                                className="img-fluid object-cover full-screen-image"
                                style={{ height: '100%', width: "100%" }} />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src={D} alt="Login Image"
                                className="img-fluid object-cover full-screen-image"
                                style={{ height: '100%', width: "100%" }} />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src={E} alt="Login Image"
                                className="img-fluid object-cover full-screen-image"
                                style={{ height: '100%', width: "100%" }} />
                        </SwiperSlide> */}
                        <SwiperSlide>
                            <img src={F} alt="Login Image"
                                className="img-fluid object-cover full-screen-image"
                                style={{ height: '100%', width: "100%" }} />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src={G} alt="Login Image"
                                className="img-fluid object-cover full-screen-image"
                                style={{ height: '100%', width: "100%" }} />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src={H} alt="Login Image"
                                className="img-fluid object-cover full-screen-image"
                                style={{ height: '100%', width: "100%" }} />
                        </SwiperSlide>
                    </Swiper>
                </Grid>

                {loginState.isLogin && <Grid item xs={12} sm={12} md={7} component={Paper} elevation={6} square>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            // background: `linear-gradient(135deg, #A6CE39 0%, #B0B0B0 100%)`,
                            backgroundColor: '#f5f5f5', // Base color
                            color: "#4A5D23",
                            backgroundSize: 'contain', // Size of the texture pattern
                            backgroundRepeat: 'no-repeat', // Repeat the texture
                            backgroundPosition: 'center', // Center the texture
                            border: '1px solid #ddd', // Light border for subtle definition
                            padding: '20px', // Padding inside the card
                            borderRadius: '8px', // Rounded corners
                            boxShadow: 3, // Shadow for the card
                            width: "100%", // Width of the
                            height: "100%", // Height of the
                        }}
                    >
                        <Avatar sx={{ m: 1, bgcolor: '#4A5D23' }}>
                            <LockOutlinedIcon />
                        </Avatar>
                        <Typography component="h1" variant="h5">
                            Sign in
                        </Typography>
                        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
                            <TextField
                                margin="normal"
                                required
                                color="success"
                                fullWidth
                                id="rsa"
                                label="RSA Pin"
                                name="rsa"
                                autoFocus

                            // sx={{
                            //     border: "#4A5D23",
                            //     '&:hover': {

                            //         backgroundColor: '#6B8E23', // Fallback color on hover
                            //         boxShadow: 6, // Increase shadow on hover
                            //         // transform: 'scale(1.05)', // Slightly scale up the card
                            //     },
                            //     '& .MuiInputBase-root': {
                            //         border: '1px solid #6B8E23', // Default border color
                            //         '&:focus': {
                            //             borderColor: '#6B8E23', // Border color when the input is focused
                            //         },

                            //     }
                            // }}
                            />
                            <TextField
                                margin="normal"
                                required
                                color="success"
                                fullWidth
                                name="password"
                                label="Password"
                                type="password"
                                id="password"
                                autoComplete="current-password"

                                sx={{
                                    border: "#4A5D23",
                                    '&:hover': {
                                        backgroundColor: '#6B8E23', // Fallback color on hover
                                        boxShadow: 6, // Increase shadow on hover
                                        // transform: 'scale(1.05)', // Slightly scale up the card
                                    },
                                    '&:active': {
                                        backgroundColor: '#6B8E23', // Fallback color on hover
                                        boxShadow: 6, // Increase shadow on hover
                                        border: "#4A5D23"
                                        // transform: 'scale(1.05)', // Slightly scale up the card
                                    }
                                }}
                            />
                            <FormControlLabel
                                control={<Checkbox value="remember" color="primary" />}
                                label="Remember me"
                            />
                            <Button
                                type="submit"
                                fullWidth

                                disabled={loading}
                                variant="contained"
                                sx={{
                                    mt: 3,
                                    mb: 2,
                                    backgroundColor: "#4A5D23",
                                    '&:hover': {

                                        backgroundColor: '#6B8E23', // Fallback color on hover
                                        boxShadow: 6, // Increase shadow on hover
                                        transform: 'scale(1.05)', // Slightly scale up the card
                                    }
                                }}
                            >
                                <Typography mr={2} variant='p'>Sign In </Typography> {loading && <SkewLoader style={{ ml: 2 }} />}
                            </Button>
                            <Grid container justifyContent={"end"} >
                                <Grid item xs>
                                    <Link onClick={() => {
                                        setLoginState({
                                            isSignUp: false,
                                            isLogin: false,
                                            isOTP: false,
                                            isRegister: false,
                                            isForgotPassword: true,
                                            isForgotPasswordToken: false,
                                        })
                                    }} sx={{ cursor: "pointer", color: "#6B8E23" }} variant="body2">
                                        Forgot password?
                                    </Link>
                                </Grid>
                                <Grid item justifyContent={"end"} >
                                    <Link onClick={() => {
                                        setLoginState({
                                            isSignUp: true,
                                            isLogin: false,
                                            isOTP: false,
                                            isRegister: false,
                                        });
                                    }} sx={{ cursor: "pointer", textAlign: "end", color: "#6B8E23" }} variant="body2">
                                        {"Don't have an account? Sign Up"}
                                    </Link>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Grid>
                }

                {loginState.isSignUp && <Grid item xs={12} sm={12} md={7} component={Paper} elevation={6} square>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            // background: `linear-gradient(135deg, #A6CE39 0%, #B0B0B0 100%)`,
                            backgroundColor: '#f5f5f5', // Base color
                            color: "#4A5D23",
                            backgroundSize: 'contain', // Size of the texture pattern
                            backgroundRepeat: 'no-repeat', // Repeat the texture
                            backgroundPosition: 'center', // Center the texture
                            border: '1px solid #ddd', // Light border for subtle definition
                            padding: '20px', // Padding inside the card
                            borderRadius: '8px', // Rounded corners
                            boxShadow: 3, // Shadow for the card
                            width: "100%", // Width of the
                            height: "100%", // Height of the
                        }}
                    >
                        <Avatar sx={{ m: 1, bgcolor: "#4A5D23" }}>
                            <LockOutlinedIcon />
                        </Avatar>
                        <Typography sx={{ fontWeight: "bolder", fontSize: "24px" }}>
                            Create an account
                        </Typography >
                        <Typography textAlign={"center"} component="h1" variant="h5">
                            Kindly enter your RSA PIN
                        </Typography>
                        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1, width: "70%" }}>
                            <TextField
                                margin="normal"
                                required
                                color="success"
                                fullWidth
                                onChange={handleChange}
                                id="pin"
                                label="RSA Pin"
                                name="pin"
                                autoFocus
                            />
                            <Button
                                type="submit"
                                fullWidth

                                disabled={loading}
                                variant="contained"
                                sx={{
                                    mt: 3, mb: 2,
                                    backgroundColor: "#4A5D23",
                                    '&:hover': {
                                        backgroundColor: '#6B8E23', // Fallback color on hover
                                        boxShadow: 6, // Increase shadow on hover
                                        // transform: 'scale(1.05)', // Slightly scale up the card
                                    },
                                    '&:active': {
                                        backgroundColor: '#6B8E23', // Fallback color on hover
                                        boxShadow: 6, // Increase shadow on hover
                                        border: "#4A5D23"
                                        // transform: 'scale(1.05)', // Slightly scale up the card
                                    }

                                }}
                            >
                                <Typography mr={2} variant='p'>Create Account</Typography>  {loading && <DotLoader style={{ ml: 1 }} />}
                            </Button>
                            <Grid container>
                                <Grid item xs>
                                    <Link onClick={() => {
                                        setLoginState({
                                            isSignUp: false,
                                            isLogin: true,
                                            isOTP: false,
                                            isRegister: false,
                                        });
                                    }} sx={{ cursor: "pointer", color: "#4A5D23" }} variant="body2">
                                        Already have an account? Log in
                                    </Link>
                                </Grid>

                            </Grid>
                        </Box>
                    </Box>
                </Grid>
                }
                {loginState.isForgotPassword && <Grid item xs={12} sm={12} md={7} component={Paper} elevation={6} square>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            // background: `linear-gradient(135deg, #A6CE39 0%, #B0B0B0 100%)`,
                            backgroundColor: '#f5f5f5', // Base color
                            color: "#4A5D23",
                            backgroundSize: 'contain', // Size of the texture pattern
                            backgroundRepeat: 'no-repeat', // Repeat the texture
                            backgroundPosition: 'center', // Center the texture
                            border: '1px solid #ddd', // Light border for subtle definition
                            padding: '20px', // Padding inside the card
                            borderRadius: '8px', // Rounded corners
                            boxShadow: 3, // Shadow for the card
                            width: "100%", // Width of the
                            height: "100%", // Height of the
                        }}
                    >
                        <Avatar sx={{ m: 1, bgcolor: "#4A5D23" }}>
                            <LockOutlinedIcon />
                        </Avatar>
                        <Typography sx={{ fontWeight: "bolder", fontSize: "24px" }}>
                            Forgot your password?
                        </Typography >
                        <Typography textAlign={"center"} component="h1" variant="h5">
                            Kindly enter your RSA PIN
                        </Typography>
                        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1, width: "70%" }}>
                            <TextField
                                margin="normal"
                                required
                                color="success"
                                fullWidth
                                onChange={handleChange}
                                id="pin"
                                label="RSA Pin"
                                name="pin"
                                autoFocus
                            />
                            <Button
                                type="submit"
                                fullWidth

                                disabled={loading}
                                variant="contained"
                                sx={{
                                    mt: 3, mb: 2,
                                    backgroundColor: "#4A5D23",
                                    '&:hover': {
                                        backgroundColor: '#6B8E23', // Fallback color on hover
                                        boxShadow: 6, // Increase shadow on hover
                                        // transform: 'scale(1.05)', // Slightly scale up the card
                                    },
                                    '&:active': {
                                        backgroundColor: '#6B8E23', // Fallback color on hover
                                        boxShadow: 6, // Increase shadow on hover
                                        border: "#4A5D23"
                                        // transform: 'scale(1.05)', // Slightly scale up the card
                                    }

                                }}
                            >
                                <Typography mr={2} variant='p'>Submit</Typography>  {loading && <DotLoader style={{ ml: 1 }} />}
                            </Button>
                            <Grid container>
                                <Grid item xs>
                                    <Link onClick={() => {
                                        setLoginState({
                                            isSignUp: false,
                                            isLogin: true,
                                            isOTP: false,
                                            isRegister: false,
                                        });
                                    }} sx={{ cursor: "pointer", color: "#4A5D23" }} variant="body2">
                                        Already have an account? Log in
                                    </Link>
                                </Grid>

                            </Grid>
                        </Box>
                    </Box>
                </Grid>
                }
                {loginState.isOTP && <Grid item xs={12} sm={12} md={7} component={Paper} elevation={6} square>
                    <Box
                        sx={{

                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            // background: `linear-gradient(135deg, #A6CE39 0%, #B0B0B0 100%)`,
                            backgroundColor: '#f5f5f5', // Base color
                            color: "#4A5D23",
                            backgroundSize: 'contain', // Size of the texture pattern
                            backgroundRepeat: 'no-repeat', // Repeat the texture
                            backgroundPosition: 'center', // Center the texture
                            border: '1px solid #ddd', // Light border for subtle definition
                            padding: '20px', // Padding inside the card
                            borderRadius: '8px', // Rounded corners
                            boxShadow: 3, // Shadow for the card
                            width: "100%", // Width of the
                            height: "100%", // Height of the
                        }}
                    >
                        <Avatar sx={{ m: 1, mb: 4, bgcolor: '#4A5D23' }}>
                            <LockOutlinedIcon />
                        </Avatar>
                        <Typography sx={{ fontWeight: "bolder" }} component="h1" variant="h5">
                            Verification Code
                        </Typography>
                        <Typography textAlign={"center"} sx={{ mb: 4 }} component="h1" variant="h5">
                            Kindly enter the 4-digit code sent to your email address.
                        </Typography>
                        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1, width: "70%" }}>
                            <OtpInput
                                value={otp}
                                onChange={handleOTPChange}
                                numInputs={4}
                                renderSeparator={<span>-</span>}
                                renderInput={(props) => <input {...props} />}
                                inputStyle={{ marginRight: "8px", marginLeft: "8px", color: "black", fontSize: "4rem", borderRadius: "8px" }}
                                containerStyle={{ padding: "8px", }}
                            />

                            <Grid container>
                                {/* <Grid item xs>
                                    <Link href="#" variant="body2">
                                        Already have an account? Sign in
                                    </Link>
                                </Grid> */}

                            </Grid>
                        </Box>
                    </Box>
                </Grid>
                }
                {loginState.isRegister && <Grid item xs={12} sm={12} md={7} component={Paper} elevation={6} square>
                    <Box
                        sx={{

                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            // background: `linear-gradient(135deg, #A6CE39 0%, #B0B0B0 100%)`,
                            backgroundColor: '#f5f5f5', // Base color
                            color: "#4A5D23",
                            backgroundSize: 'contain', // Size of the texture pattern
                            backgroundRepeat: 'no-repeat', // Repeat the texture
                            backgroundPosition: 'center', // Center the texture
                            border: '1px solid #ddd', // Light border for subtle definition
                            padding: '20px', // Padding inside the card
                            borderRadius: '8px', // Rounded corners
                            boxShadow: 3, // Shadow for the card
                            width: "100%", // Width of the
                            height: "100%", // Height of the
                        }}
                    >
                        <Avatar sx={{ m: 1, bgcolor: "#4A5D23" }}>
                            <LockOutlinedIcon />
                        </Avatar>
                        <Typography sx={{ fontWeight: "bolder" }} component="h1" variant="h5">
                            Set your password
                        </Typography>
                        <Typography textAlign={"center"} component="h1" variant="h5">
                            {isUpdate ? `Update your fidelity pension account app password.` : `Create a password for your fidelity pension account app.`}
                        </Typography>
                        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1, width: "70%" }}>
                            <TextField
                                margin="normal"
                                required
                                color="success"
                                fullWidth
                                id="password"
                                onChange={handleChange}
                                label="Password"
                                name="password"
                                type="password"
                                autoFocus
                            />
                            <TextField
                                margin="normal"
                                required
                                color="success"
                                fullWidth
                                name="confirmPassword"
                                onChange={handleChange}
                                label="Confirm Password"
                                type="password"
                                id="confirmPassword"
                                autoComplete="current-password"
                            />

                            <Button
                                type="submit"
                                fullWidth

                                disabled={loading}
                                variant="contained"
                                sx={{
                                    mt: 3, mb: 2,
                                    backgroundColor: "#4A5D23"
                                    ,

                                    '&:hover': {
                                        backgroundColor: '#6B8E23', // Fallback color on hover
                                        boxShadow: 6, // Increase shadow on hover
                                        // transform: 'scale(1.05)', // Slightly scale up the card
                                    },
                                    '&:active': {
                                        backgroundColor: '#6B8E23', // Fallback color on hover
                                        boxShadow: 6, // Increase shadow on hover
                                        border: "#4A5D23"
                                        // transform: 'scale(1.05)', // Slightly scale up the card
                                    }
                                }}
                            >
                                Set Password {loading && <DotLoader style={{ ml: 1 }} />}
                            </Button>
                            <Grid justifyContent={"end"} container >
                                <Grid justifyContent={"end"} item xs>
                                    <Link onClick={() => {
                                        setLoginState({
                                            isSignUp: false,
                                            isLogin: true,
                                            isOTP: false,
                                            isRegister: false,
                                        });
                                    }} sx={{
                                        cursor: "pointer",
                                        textAlign: "end",
                                        color: "#4A5D23",
                                        width: "100%"
                                    }} variant="body2">
                                        Already have an account? Log in
                                    </Link>
                                </Grid>

                            </Grid>

                        </Box>
                    </Box>
                </Grid>
                }
                {loginState.isForgotPasswordToken && <Grid item xs={12} sm={12} md={7} component={Paper} elevation={6} square>
                    <Box
                        sx={{

                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            // background: `linear-gradient(135deg, #A6CE39 0%, #B0B0B0 100%)`,
                            backgroundColor: '#f5f5f5', // Base color
                            color: "#4A5D23",
                            backgroundSize: 'contain', // Size of the texture pattern
                            backgroundRepeat: 'no-repeat', // Repeat the texture
                            backgroundPosition: 'center', // Center the texture
                            border: '1px solid #ddd', // Light border for subtle definition
                            padding: '20px', // Padding inside the card
                            borderRadius: '8px', // Rounded corners
                            boxShadow: 3, // Shadow for the card
                            width: "100%", // Width of the
                            height: "100%", // Height of the
                        }}
                    >
                        <Avatar sx={{ m: 1, bgcolor: "#4A5D23" }}>
                            <LockOutlinedIcon />
                        </Avatar>
                        <Typography sx={{ fontWeight: "bolder" }} component="h1" variant="h5">
                            Set your password
                        </Typography>
                        <Typography textAlign={"center"} component="h1" variant="h5">
                            {`Enter token and new password to complete reset`}
                        </Typography>
                        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1, width: "70%" }}>
                            <TextField
                                margin="normal"
                                required
                                color="success"
                                fullWidth
                                id="token"
                                onChange={handleChange}
                                label="Token"
                                name="token"
                                type="token"
                                autoFocus
                            />
                            <TextField
                                margin="normal"
                                required
                                color="success"
                                fullWidth
                                id="newPassword"
                                onChange={handleChange}
                                label="New Password"
                                name="newPassword"
                                type="newPassword"
                                autoFocus
                            />
                            <TextField
                                margin="normal"
                                required
                                color="success"
                                fullWidth
                                name="confirmPassword"
                                onChange={handleChange}
                                label="Confirm Password"
                                type="password"
                                id="confirmPassword"
                                autoComplete="current-password"
                            />

                            <Button
                                type="submit"
                                fullWidth

                                disabled={loading}
                                variant="contained"
                                sx={{
                                    mt: 3, mb: 2,
                                    backgroundColor: "#4A5D23"
                                    ,

                                    '&:hover': {
                                        backgroundColor: '#6B8E23', // Fallback color on hover
                                        boxShadow: 6, // Increase shadow on hover
                                        // transform: 'scale(1.05)', // Slightly scale up the card
                                    },
                                    '&:active': {
                                        backgroundColor: '#6B8E23', // Fallback color on hover
                                        boxShadow: 6, // Increase shadow on hover
                                        border: "#4A5D23"
                                        // transform: 'scale(1.05)', // Slightly scale up the card
                                    }
                                }}
                            >
                                Reset Password {loading && <DotLoader style={{ ml: 1 }} />}
                            </Button>
                            <Grid justifyContent={"end"} container >
                                <Grid justifyContent={"end"} item xs>
                                    <Link onClick={() => {
                                        setLoginState({
                                            isSignUp: false,
                                            isLogin: true,
                                            isOTP: false,
                                            isRegister: false,
                                        });
                                    }} sx={{
                                        cursor: "pointer",
                                        textAlign: "end",
                                        color: "#4A5D23",
                                        width: "100%"
                                    }} variant="body2">
                                        Already have an account? Log in
                                    </Link>
                                </Grid>

                            </Grid>

                        </Box>
                    </Box>
                </Grid>
                }
            </Grid>
        </ThemeProvider >
    );
}